import React, { useState, useEffect } from 'react';
import korrectLogo from '../../../assets/images/korrectLogoIcon.png';
import assetsCompareServices from './assetsCompareServices';
import Pagination from '../../Header/Pagination';
import cachingMechanisum from '../../Common/cachingMechanisum';

export default function AssetCompareSimple() {

    let [totalRows, setTotalRows] = useState(0);
    let [searchFor, setsearchFor] = useState("");
    let [AssetType, setAssetType] = useState("tracks");
    let [rawData, setRawData] = useState<any>([]);
    let [exclude, setExclude] = useState<any>([]);
    let [openInclude, setOpenInclude] = useState(false);
    let [categoryList, setCategoryList] = useState<any[]>([]);
    let [adminSelectedCount, setAdminSelectedCount] = useState(0);
    let [korrectSelectedCount, setKorrectSelectedCount] = useState(0);
    let [payload, setPayload] = useState({ pageNumber: 1, pageSize: 10 });
    let [assetListMethod, setAssetListMethod] = useState("nonexistPortal");
    let [adminAssetsListPagination, setAdminAssetsListPagination] = useState<any[]>([]);
    let [korrectAssetsListPagination, setKorrectAssetsListPagination] = useState<any[]>([]);
    let [criteriaParamsSelection, setCriteriaParamsSelection] = useState<any[]>([
        { selection: false, value: "Release Title", criteria: 'RTitle' },
        { selection: false, value: "Track Title", criteria: 'TTitle' },
        { selection: false, value: "Release Artist", criteria: 'RArtist' },
        { selection: false, value: "Track Artist", criteria: 'TArtist' },
        { selection: false, value: "ISRC", criteria: 'ISRC' },
        { selection: false, value: "Catalog Number", criteria: 'catlogNum' },
        { selection: false, value: "Custom ID", criteria: 'CustomID' },
        { selection: false, value: "Song Code", criteria: 'songCode' }
    ]);
    let [ReleaseOnKorrectOnly, setReleaseOnKorrectOnly] = useState();
    let [SongsOnKorrectOnly, setSongsOnKorrectOnly] = useState();
    let [TracksOnKorrectOnly, setTracksOnKorrectOnly] = useState();

    let [ReleaseOnPortalOnly, setReleaseOnPortalOnly] = useState();
    let [SongsOnPortalOnly, setSongsOnPortalOnly] = useState();
    let [TracksOnPortalOnly, setTracksOnPortalOnly] = useState();

    let [clientLogo, setclientLogo] = useState<any>([]);
    useEffect(() => {
        searchFor = "";
        //trackFilter(AssetType);
        AssetType = 'tracks'
        setAssetType(AssetType);
        addTabName(4);
        assetListMethod = 'nonexistPortal';
        setAssetListMethod(assetListMethod);

        //getAssetCompareData();
        setAdminSelectedCount(0);
        setKorrectSelectedCount(0);
        clientLogo = cachingMechanisum.getCachingStorage("ClientImage")
        setclientLogo(clientLogo)
    }, [])

    useEffect(() => {
        setRawData(rawData);
        setAdminAssetsListPagination(rawData?.adminAssets?.slice((payload.pageNumber - 1) * payload.pageSize, (payload.pageSize * payload.pageNumber)));
        setKorrectAssetsListPagination(rawData?.korrectAssets?.slice((payload.pageNumber - 1) * payload.pageSize, (payload.pageSize * payload.pageNumber)));
    }, [rawData])

    const removeTabName = (index: any) => {
        criteriaParamsSelection[index].selection = false;
        setCriteriaParamsSelection(existingValues => [...criteriaParamsSelection]);
    }

    const addTabName = (index: any) => {
        criteriaParamsSelection[index].selection = true;
        setCriteriaParamsSelection(existingValues => [...criteriaParamsSelection]);
    }



    let [differentKorrectTracksCacheKey, setdifferentKorrectTracksCacheKey] = useState();
    let [differentPortalTracksCacheKey, setdifferentPortalTracksCacheKey] = useState();

    let [differentKorrectReleasesCacheKey, setdifferentKorrectReleasesCacheKey] = useState();
    let [differentPortalReleasesCacheKey, setdifferentPortalReleasesCacheKey] = useState();

    let [differentKorrectSongsCacheKey, setdifferentKorrectSongsCacheKey] = useState();
    let [differentPortalSongsCacheKey, setdifferentPortalSongsCacheKey] = useState();

    const getAssetCompareData = () => {
        setAssetListMethod(assetListMethod);
        setAdminSelectedCount(0);
        setKorrectSelectedCount(0);

        const criteriaParams = {
            searchFor: searchFor,
            method: assetListMethod,
            type: AssetType
        }

        for (var $i = 0; $i < criteriaParamsSelection?.length; $i++) {
            if (criteriaParamsSelection[$i].selection) {
                Object.assign(criteriaParams, { [criteriaParamsSelection[$i].criteria]: true });
            } else {
                Object.assign(criteriaParams, { [criteriaParamsSelection[$i].criteria]: false });
            }
        }

        console.log("res")
        assetsCompareServices.getMinimumSetAssetCompare(criteriaParams).then((res) => {

            console.log(res)
            setRawData(res);
            setAdminAssetsListPagination(res?.adminAssets?.slice((0) * 10, (10)));
            setKorrectAssetsListPagination(res?.korrectAssets?.slice((0) * 10, (10)));

            console.log(adminAssetsListPagination)
            console.log(korrectAssetsListPagination)

            ReleaseOnKorrectOnly = res?.onlyKorrectReleasesCacheKey;
            setReleaseOnKorrectOnly(ReleaseOnKorrectOnly)

            SongsOnKorrectOnly = res?.onlyKorrectSongsCacheKey;
            setSongsOnKorrectOnly(SongsOnKorrectOnly)

            TracksOnKorrectOnly = res?.onlyKorrectTracksCacheKey;
            setTracksOnKorrectOnly(TracksOnKorrectOnly)


            ReleaseOnPortalOnly = res?.onlyPortalReleasesCacheKey;
            setReleaseOnPortalOnly(ReleaseOnPortalOnly)

            SongsOnPortalOnly = res?.onlyPortalSongsCacheKey;
            setSongsOnPortalOnly(SongsOnPortalOnly)

            TracksOnPortalOnly = res?.onlyPortalTracksCacheKey;
            setTracksOnPortalOnly(TracksOnPortalOnly)


            differentPortalTracksCacheKey = res?.differentPortalTracksCacheKey;
            setdifferentPortalTracksCacheKey(differentPortalTracksCacheKey);

            differentKorrectReleasesCacheKey = res?.differentKorrectReleasesCacheKey;
            setdifferentKorrectReleasesCacheKey(differentKorrectReleasesCacheKey);

            differentPortalReleasesCacheKey = res?.differentPortalReleasesCacheKey;
            setdifferentPortalReleasesCacheKey(differentPortalReleasesCacheKey);

            differentKorrectTracksCacheKey = res?.differentKorrectTracksCacheKey;
            setdifferentKorrectTracksCacheKey(differentKorrectTracksCacheKey);

            differentKorrectSongsCacheKey = res?.differentKorrectSongsCacheKey;
            setdifferentKorrectSongsCacheKey(differentKorrectSongsCacheKey);

            differentPortalSongsCacheKey = res?.differentPortalSongsCacheKey;
            setdifferentPortalSongsCacheKey(differentPortalSongsCacheKey);

            if (assetListMethod === "nonexistPortal") {
                //console.log(res[0]);
                setTotalRows(res?.korrectAssets?.length)
            }
            if (assetListMethod === "nonexistKorrect") {
                //console.log(res[0]);
                setTotalRows(res?.adminAssets?.length)
            }
            if (assetListMethod === "existDifference") {
                //console.log(res[0]);
                setTotalRows(res?.adminAssets?.length)
            }
        })
    }

    const exportListings = (value: any, type: any) => {
        console.log(type)
        console.log(value)

        var selectAsset: any = [];

        //Build Object selected list adminAssets
        for (var $i = 0; $i < rawData?.adminAssets?.length; $i++) {

            if (type === "All") {
                console.log(rawData?.adminAssets[$i].ISRC + " AND " + rawData?.adminAssets[$i].CatalogNumber);
                //adminSelectedExp.push({ ISRC : rawData.adminAssets[$i].ISRC , catalogNumber : rawData.adminAssets[$i].catalogNumber  })
            }

            if (type === "selected" && rawData?.adminAssets[$i]?.selected === true) {
                console.log(rawData?.adminAssets[$i].ISRC + " AND " + rawData.adminAssets[$i].CatalogNumber);
                selectAsset.push({ ISRC: rawData.adminAssets[$i].ISRC, catalogNumber: rawData.adminAssets[$i].CatalogNumber })
            }
        }

        //Build Object selected list korrectAssets
        for (var $i = 0; $i < rawData?.korrectAssets?.length; $i++) {

            if (type === "All") {
                console.log(rawData.korrectAssets[$i].ISRC + " AND " + rawData.korrectAssets[$i].catalogNumber);
                //korrectASelectedExp.push({ ISRC : rawData.korrectAssets[$i].ISRC , catalogNumber : rawData.korrectAssets[$i].catalogNumber  })
            }

            if (type === "selected" && rawData?.korrectAssets[$i]?.selected === true) {
                console.log(rawData.korrectAssets[$i].ISRC + " AND " + rawData.korrectAssets[$i].catalogNumber);
                selectAsset.push({ ISRC: rawData.korrectAssets[$i].ISRC, catalogNumber: rawData.korrectAssets[$i].catalogNumber })
            }
        }

        console.log(selectAsset)
        const criteriaParams = {
            //link: "https://master.dws03r4d6820k.amplifyapp.com/api/assets/",
            //xapikey: "25520aaf-e317-4794-822f-8aae77b48c28",
            ExportType: value,
            searchFor: searchFor,
            assetList: selectAsset,
            method: assetListMethod,
            onlyKorrectReleasesCacheKey: ReleaseOnKorrectOnly,
            onlyKorrectSongsCacheKey: SongsOnKorrectOnly,
            onlyKorrectTracksCacheKey: TracksOnKorrectOnly,
            onlyPortalReleasesCacheKey: value === "adminAssets" ? '' : ReleaseOnPortalOnly,
            onlyPortalSongsCacheKey: value === "adminAssets" ? '' : SongsOnPortalOnly,
            onlyPortalTracksCacheKey: value === "adminAssets" ? '' : TracksOnPortalOnly,
            differentPortalTracksCacheKey: differentPortalTracksCacheKey,
            differentKorrectReleasesCacheKey: differentKorrectReleasesCacheKey,
            differentPortalReleasesCacheKey: differentPortalReleasesCacheKey,
            differentKorrectTracksCacheKey: differentKorrectTracksCacheKey,
            differentKorrectSongsCacheKey: differentKorrectSongsCacheKey,
            differentPortalSongsCacheKey: differentPortalSongsCacheKey,
            allKorrectSongsCacheKey: "",
            allKorrectTracksCacheKey: "",
            type: AssetType
        }

        for (var $i = 0; $i < criteriaParamsSelection?.length; $i++) {
            if (criteriaParamsSelection[$i].selection) {
                Object.assign(criteriaParams, { [criteriaParamsSelection[$i].criteria]: true });
            } else {
                Object.assign(criteriaParams, { [criteriaParamsSelection[$i].criteria]: false });
            }
        }

        console.log(criteriaParams);
        assetsCompareServices.AssetComparisonMinSetExport(criteriaParams).then((res) => { });
    }

    const compareDataField = (firstVal: any, secondVal: any, index: any) => {

        let tempText = 'bg-level10';
        if (index === 1) {
            tempText = 'bg-level16';
        }

        if (firstVal && !secondVal) {
            return tempText
        }

        if (!firstVal && secondVal) {
            return tempText
        }

        if (firstVal !== secondVal) {
            return tempText
        }

        if (firstVal === secondVal) {
            return ""
        }

        if (firstVal.length === 0 && secondVal.length === 0) {
            return ""
        }

        if (firstVal === null && secondVal === null) {
            return ""
        }

    }

    const searchSummary = (e: any) => {
        
        console.log(e)
        setsearchFor(e);

        if (e && e.length > 0) {
            var tempKorrect = [];
            var tempAdmin = [];
            var searchKorrect: any = [];
            var searchAdmin: any = [];

            tempKorrect = rawData?.korrectAssets?.map((item: any, index: any) => {
                if (item?.ISRC?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.catalogNumber?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||

                    item?.trackTitle?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.name?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||

                    item?.releaseArtistName?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.name?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.trackArtistName?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.trackArtist?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.customID?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||

                    item?.songCode?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.songTitle?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.songWriters?.toLocaleLowerCase().includes(e.toLocaleLowerCase())



                ) {
                    return index;
                }
                return null;
            }).filter((index: any) => index !== null);


            tempAdmin = rawData?.adminAssets?.map((item: any, index: any) => {
                if (item?.ISRC?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.releaseCode?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||

                    item?.trackTitle?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.releaseName?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||

                    item?.trackArtist?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.releaseArtist?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||

                    item?.customID?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.songCode?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.songTitle?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
                    item?.songWriters?.toLocaleLowerCase().includes(e.toLocaleLowerCase())

                ) {
                    return index;
                }
                return null;
            }).filter((index: any) => index !== null);

            const mergedArray = Array.from(new Set([...tempAdmin || [], ...tempKorrect || []]));

            if (mergedArray.length > 0) {
                for (var $i = 0; $i < mergedArray.length; $i++) {
                    const index = mergedArray[$i];

                    if (rawData?.korrectAssets && rawData?.korrectAssets[index]) {
                        searchKorrect.push(rawData?.korrectAssets[index]);
                    }
                    if (rawData?.adminAssets && rawData?.adminAssets[index]) {
                        searchAdmin.push(rawData?.adminAssets[index]);
                    }

                    console.log(searchKorrect)
                    console.log(searchAdmin)
                }
            }

            setAdminAssetsListPagination(searchAdmin.slice((payload.pageNumber - 1) * payload.pageSize, (payload.pageSize * payload.pageNumber)));
            setKorrectAssetsListPagination(searchKorrect.slice((payload.pageNumber - 1) * payload.pageSize, (payload.pageSize * payload.pageNumber)));

            totalRows = mergedArray.length
            setTotalRows(totalRows)
        }

        if (e.length === 0) {
            getAssetCompareData();
        }
    }

    const paginationHandler = (n: any) => {
        console.log(n);
        payload.pageNumber = n.pageNumber;
        payload.pageSize = n.pageSize;
        setPayload(payload)
        rawData = rawData
        setRawData(rawData);
        if (searchFor.length === 0) {
            setAdminAssetsListPagination(rawData?.adminAssets?.slice((n.pageNumber - 1) * n.pageSize, (n.pageSize * n.pageNumber)));
            setKorrectAssetsListPagination(rawData?.korrectAssets?.slice((n.pageNumber - 1) * n.pageSize, (n.pageSize * n.pageNumber)));
        }

        if (searchFor.length > 0) {
            searchSummary(searchFor)
        }
        console.log(payload);
    }

    const selectIndividual = (type: any, index: any) => {
        var correctIndex = (payload.pageNumber - 1) * payload.pageSize + index;
        const updatedRawData = { ...rawData };

        console.log(type)
        console.log(index)
        if (type === 'korrect') {

            if (updatedRawData?.adminAssets && updatedRawData.adminAssets[correctIndex]) {
                updatedRawData.adminAssets[correctIndex].selected = !updatedRawData.adminAssets[correctIndex].selected;
            }

            if (updatedRawData?.korrectAssets && updatedRawData.korrectAssets[correctIndex]) {
                updatedRawData.korrectAssets[correctIndex].selected = false;
            }

            rawData = updatedRawData;
            setRawData(rawData);
        }

        if (type === 'admin') {

            if (updatedRawData?.korrectAssets && updatedRawData.korrectAssets[correctIndex]) {
                updatedRawData.korrectAssets[correctIndex].selected = !updatedRawData.korrectAssets[correctIndex].selected;
            }

            if (updatedRawData?.adminAssets && updatedRawData.adminAssets[correctIndex]) {
                updatedRawData.adminAssets[correctIndex].selected = false;
            }
            rawData = updatedRawData;
            setRawData(rawData);
        }

        var adminResult = updatedRawData?.adminAssets.filter((e: any) => e?.selected === true);
        adminSelectedCount = adminResult.length;
        setAdminSelectedCount(adminSelectedCount);

        var korrectResult = updatedRawData?.korrectAssets.filter((e: any) => e?.selected === true);
        korrectSelectedCount = korrectResult.length;
        setKorrectSelectedCount(korrectSelectedCount);
        console.log(rawData)
    }

    const checkBoxValue = (type: any, index: any) => {
        var return_val = false;
        var correctIndex = (payload.pageNumber - 1) * payload.pageSize + index;

        //console.log("checkBoxValue " + "correctIndex: " + correctIndex + " type: " + type + " index: " + index);
        //console.log("Current " + return_val)

        if (type === 'korrect') {
            if (rawData?.korrectAssets && rawData.korrectAssets[correctIndex]) {
                return_val = rawData.korrectAssets[correctIndex].selected  //? rawData.adminAssets[correctIndex].selected  : false;
                //console.log("after " + return_val)
                return return_val;
            }
        }

        if (type === 'admin') {
            if (rawData?.adminAssets && rawData.adminAssets[correctIndex]) {
                return_val = rawData.adminAssets[correctIndex].selected //? rawData.adminAssets[correctIndex].selected  : false; 
                //console.log("after " + return_val)
                return return_val;
            }
        }
    }

    const CreateAsset = (type: any) => {
        console.log(type)
        var selectedSaveList: any = [];

        if (type === "All") {
            console.log(rawData.adminAssets)

            for (var $i = 0; $i < rawData.adminAssets.length; $i++) {
                console.log(rawData.adminAssets[$i].ISRC + " AND " + rawData.adminAssets[$i].CatalogNumber);
                selectedSaveList.push(adminAssetsListPagination[$i]);
            }
        }

        if (type === "Selected") {
            console.log(rawData.adminAssets)
            for (var $i = 0; $i < rawData.adminAssets.length; $i++) {

                if (rawData.adminAssets[$i] && rawData.adminAssets[$i].selected) {
                    console.log(rawData.adminAssets[$i].ISRC + " AND " + rawData.adminAssets[$i].CatalogNumber);
                    selectedSaveList.push(rawData.adminAssets[$i]);
                }
            }
        }
        console.log(selectedSaveList);

        assetsCompareServices.korrectUpdateAssetCompare(selectedSaveList);
    }

    const exportPhyAssetCompare = () => {
        var payload = {
            "CustomID": false,
            "RTitle": true,
            "TTitle": false,
            "RArtist": false,
            "TArtist": false,
            "ISRC": false,
            "catlogNum": true,
            "method": assetListMethod,
            "assetList": [],
            "ExportType": "adminAssets"
        }

        assetsCompareServices.exportPhyAssetCompare(payload)
    }

    const trackFilter = (type: any) => {
        console.log(type)
        removeTabName(0);
        removeTabName(1);
        removeTabName(2);
        removeTabName(3);
        removeTabName(4);
        removeTabName(5);
        removeTabName(6);
        removeTabName(7);
        if (type === 'tracks') {
            AssetType = 'tracks'
            setAssetType(AssetType);
            addTabName(4);
            assetListMethod = 'nonexistPortal';
            setAssetListMethod(assetListMethod);
            getAssetCompareData();
        }

        if (type === 'songs') {
            AssetType = 'songs'
            setAssetType(AssetType);
            addTabName(7);
            assetListMethod = 'nonexistPortal';
            setAssetListMethod(assetListMethod);
            getAssetCompareData();
        }

        if (type === 'releases') {
            AssetType = 'releases'
            setAssetType(AssetType);
            addTabName(5);
            assetListMethod = 'nonexistPortal';
            setAssetListMethod(assetListMethod);
            getAssetCompareData();
        }
    }

    return (<>
        <div className="landing ws-12">

            <div className='ws-12 pLarge'>

                <div className="ws-12 ptxl mtl">
                    <span className="ws-12 text-bold text-xl">Asset Management</span>
                    <span className="ws-12 ptl text-bold text-m turquoise">Asset Compare</span>
                </div>

                <div className="ws-12 ptxl">

                    <div className="ws-12 mbl">
                        <button className="btn white pLarge bg-level14 m0 ws-2" onClick={() => searchSummary(searchFor)}> Search</button>
                        <input type="text" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} className="pLarge ws-10 m0 heightReset" placeholder="Type to search" />
                    </div>

                </div>

                <div className='ws-12 bgWhite'>

                    <div className="ws-12 box">

                        <div className='ws-12'>
                            <ul className="nav nav-tabs p0 m0 pull-right">
                                <li className={AssetType === "tracks" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => trackFilter("tracks")}>Tracks</li>
                                <li className={AssetType === "songs" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => trackFilter("songs")}>Songs</li>
                                <li className={AssetType === "releases" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => trackFilter("releases")}>Releases</li>
                            </ul>
                        </div>

                        <div className="pm ws-12 ">
                            <span className="pull-left pt text-bold text-m mr mt">Criteria : </span>

                            {criteriaParamsSelection?.map((item: any, index: any) => {
                                return (
                                    <>{<div className={item.selection ? 'tagging bg-level1 mr forceSingleLine' : 'hide'}>
                                        <span className="bgTransparent text-bold">{item.value}</span>
                                        <a className="btn-info pull-left btn-xxs borderNone bgTransparent m0 hide" onClick={() => removeTabName(index)}><i className="icon-cross1 text-s mt"></i></a>
                                    </div>}</>
                                )
                            })}

                            <a className="p0 pull-left icon-btn edit borderNone bgTransparent m0 hide" onClick={() => setOpenInclude(!openInclude)}><i className="icon-plus text-xxl"></i></a>
                        </div>

                        {openInclude && true && <> <hr />
                            <div className="pm ws-12">

                                {criteriaParamsSelection?.map((item: any, index: any) => {
                                    return (
                                        <>{<div className={item.selection ? 'hide' : "tagging bg-level1 mr forceSingleLine"}>
                                            <span className="bgTransparent text-bold">{item.value}</span>
                                            <a className="btn-info pull-left btn-xxs borderNone bgTransparent m0" onClick={() => { addTabName(index) }}><i className="icon-plus"></i></a>
                                        </div>}</>
                                    )
                                })}

                                {categoryList?.map((list: any) => {
                                    return (<>
                                        {(() => {
                                            if (exclude.filter((e: any) => e === list).length === 0) {
                                                return (
                                                    <div className="tagging bg-level1 mr forceSingleLine">
                                                        <span className="bgTransparent text-bold">{list}</span>
                                                        <a className="btn-info pull-left btn-xxs borderNone bgTransparent" onClick={() => addTabName(list)}><i className="icon-plus2 text-s mt"></i></a>
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </>)
                                })}
                            </div>

                        </>}

                        <div className="ws-12 pm">

                            <ul className='nav nav-tabs mbll mtll ws-6'>
                                <li className={assetListMethod === 'nonexistPortal' ? 'active' : ''} onClick={() => { assetListMethod = 'nonexistPortal'; getAssetCompareData(); }}>On Korrect Only</li>
                                <li className={assetListMethod === 'nonexistKorrect' ? 'active' : ''} onClick={() => { assetListMethod = 'nonexistKorrect'; getAssetCompareData(); }}>On Portal Only</li>
                                <li className={assetListMethod === 'existDifference' ? 'active' : ''} onClick={() => { assetListMethod = 'existDifference'; getAssetCompareData(); }}>Different</li>
                            </ul>

                            <div className='mbll mtll pull-right ws-6'>

                                {(assetListMethod === 'nonexistKorrect' || assetListMethod === 'existDifference') && <div className='verticalMediumWide hover-box pull-right forceSingleLine prl'>
                                    <a className="white ws-12 m0 bg-level7 pm  btn-m" onClick={() => { exportListings('korrectAssets', "selected") }}>Export For Korrect {(adminSelectedCount > 0) && <span className='white'> ({adminSelectedCount}) </span>}</a>
                                    <div className="hover-block mtlxl pt bgTransparent">
                                        <a className="icon-btn edit btn-xs" onClick={() => { exportListings('korrectAssets', "All") }}>Export All For Korrect</a>
                                        <a className="icon-btn edit btn-xs mt" onClick={() => { exportPhyAssetCompare(); }}>Export Physical Data</a>
                                    </div>
                                </div>}

                                {(assetListMethod === 'nonexistPortal' || assetListMethod === 'existDifference') && <div className='verticalMediumWide hover-box pull-right forceSingleLine prl'>
                                    <a className="white ws-12 m0 bg-level7 pm  btn-m" onClick={() => { exportListings('adminAssets', "selected") }}>Export For Portal {(korrectSelectedCount > 0) && <span className='white'> ({korrectSelectedCount}) </span>}</a>
                                    <div className="hover-block mtlxl pt bgTransparent">
                                        <a className="icon-btn edit btn-xs" onClick={() => { exportListings('adminAssets', "All") }}>Export All For Portal</a>
                                    </div>
                                </div>}

                                {(assetListMethod === 'nonexistKorrect') && <div className='verticalMediumWide hover-box pull-right forceSingleLine prl hide'>
                                    <a className="white ws-12 m0 bg-level7 pm  btn-m" onClick={() => CreateAsset("Selected")}>Create Assets {(adminSelectedCount > 0) && <span className='white'> ({adminSelectedCount}) </span>}</a>
                                    <div className="hover-block mtlxl pt bgTransparent">
                                        <a className="icon-btn edit btn-xs " onClick={() => CreateAsset("All")}>Create All Assets</a>
                                    </div>
                                </div>}

                            </div>
                        </div>

                        {(totalRows > 0) && <div className={'ws-12 pm ptl pt pb'}><span className="text-bold text-m">Showing <span className="info">{totalRows}</span> results</span></div>}

                        {(totalRows > 0) && <div className='ws-12 mtl pLarge tableVertical'>
                            <table className={'tableVertical ws-12'}>
                                <thead>
                                    <tr>
                                        {assetListMethod === 'existDifference' && <th className=''> </th>}
                                        {AssetType === "releases" && <th className="text- bgDark">Release Code</th>}
                                        {AssetType === "releases" && <th className="text- bgDark">Release Title</th>}
                                        {AssetType === "releases" && <th className="text- bgDark">Release Artist</th>}
                                        {AssetType === "releases" && <th className="text- bgDark">CustomID</th>}

                                        {AssetType === "tracks" && <th className="text- bgDark">ISRC</th>}
                                        {AssetType === "tracks" && <th className="text- bgDark">Track Title</th>}
                                        {AssetType === "tracks" && <th className="text- bgDark">Track Artist</th>}

                                        {AssetType === "songs" && <th className="text- bgDark">Song Code</th>}
                                        {AssetType === "songs" && <th className="text- bgDark">Song Title</th>}
                                        {AssetType === "songs" && <th className="text- bgDark">Song Writers</th>}
                                    </tr>
                                </thead>
                                <tbody>

                                    {assetListMethod === 'existDifference' && korrectAssetsListPagination && <> {korrectAssetsListPagination?.map((list: any, index: any) => {
                                        return (
                                            <>
                                                <tr className='bg-level1'>
                                                    <td width='5%' className='ptl pbl '>
                                                        <input className='mt mrl hide' type='radio' name={index} checked={checkBoxValue("korrect", index)} onClick={(e) => selectIndividual("admin", index)} />
                                                        <img className="pull-none" src={korrectLogo} width={20} />
                                                    </td>
                                                    {AssetType === "releases" && <td width="20%"  >{list?.catalogNumber}</td>}
                                                    {AssetType === "releases" && <td width="20%"     >{list?.name}</td>}
                                                    {AssetType === "releases" && <td width="20%"   >{list?.releaseArtistName}</td>}
                                                    {AssetType === "releases" && <td width="20%"    >{list?.customID}</td>}

                                                    {AssetType === "tracks" && <td width="30%"    >  {list?.ISRC}</td>}
                                                    {AssetType === "tracks" && <td width="30%"      >{list?.trackTitle}</td>}
                                                    {AssetType === "tracks" && <td width="30%"     >{list?.trackArtist ? list?.trackArtist : list?.trackArtistName ? list?.trackArtistName : ''}</td>}
                                                </tr>

                                                <tr className='bg-level8'>
                                                    <td className='ptl pbl '>
                                                        <input className='mt mrl hide' type='radio' name={index} value='admin' checked={checkBoxValue("admin", index)} onClick={(e) => selectIndividual("korrect", index)} />
                                                        <img className="pull-none" src={clientLogo ? clientLogo : '/assets/images/logo.png'} width={40} />
                                                    </td>
                                                    {AssetType === "releases" && <td width="20%"  >{adminAssetsListPagination?.[index]?.CatalogNumber}</td>}
                                                    {AssetType === "releases" && <td width="20%"  >{adminAssetsListPagination?.[index]?.ReleaseTitle}</td>}
                                                    {AssetType === "releases" && <td width="20%"  >{adminAssetsListPagination?.[index]?.ReleaseArtist}</td>}
                                                    {AssetType === "releases" && <td width="20%"  >{adminAssetsListPagination?.[index]?.customID}</td>}

                                                    {AssetType === "tracks" && <td width="30%" >{adminAssetsListPagination?.[index]?.iSRC}</td>}
                                                    {AssetType === "tracks" && <td width="30%" >{adminAssetsListPagination?.[index]?.trackName}</td>}
                                                    {AssetType === "tracks" && <td width="30%" >{adminAssetsListPagination?.[index]?.trackArtist}</td>}
                                                </tr>
                                            </>
                                        )
                                    })}</>}

                                    {assetListMethod === 'nonexistKorrect' && <> {adminAssetsListPagination?.map((list: any, index: any) => {
                                        return (<>
                                            <tr className={index % 2 === 0 ? 'bg-level1' : 'bg-level8'}>
                                                <td width='5%' className='ptl pbl hide'>
                                                    <input className='mt mrl' type='checkbox' name={index} checked={checkBoxValue("korrect", index)} onClick={(e) => selectIndividual("korrect", index)} />
                                                    <img className="pull-none" src={clientLogo ? clientLogo : '/assets/images/logo.png'} width={40} />
                                                </td>
                                                {AssetType === "tracks" && <td width='13%'>{list?.iSRC}</td>}
                                                {AssetType === "tracks" && <td width='13%'>{list?.trackName}</td>}
                                                {AssetType === "tracks" && <td width='13%'>{list?.trackArtist}</td>}

                                                {AssetType === "releases" && <td width='13%'>{list?.catalogNumber}</td>}
                                                {AssetType === "releases" && <td width='13%'>{list?.releaseTitle}</td>}
                                                {AssetType === "releases" && <td width='13%'>{list?.releaseArtist}</td>}
                                                {AssetType === "releases" && <td width='13%'>{list?.customID}</td>}


                                                {AssetType === "songs" && <td width='13%'>{list?.songCode}</td>}
                                                {AssetType === "songs" && <td width='13%'>{list?.songTitle}</td>}
                                                {AssetType === "songs" && <td width='13%'>{list?.songWriters}</td>}
                                            </tr>
                                        </>)
                                    })}</>}

                                    {assetListMethod === 'nonexistPortal' && <> {korrectAssetsListPagination?.map((list: any, index: any) => {
                                        return (<>
                                            <tr className={index % 2 === 0 ? 'bg-level8' : 'bg-red'}>
                                                <td className='ptl pbl hide'>
                                                    <input className='mt mrl' type='checkbox' name={index} value='admin' checked={checkBoxValue("korrect", index)} onChange={(e) => selectIndividual("admin", index)} />
                                                    <img className="pull-none" src={korrectLogo} width={20} />
                                                </td>
                                                {AssetType === "releases" && <td width='23%'>{list?.catalogNumber}</td>}
                                                {AssetType === "releases" && <td width='23%'>{list?.name}</td>}
                                                {AssetType === "releases" && <td width='23%'>{list?.releaseArtistName}</td>}
                                                {AssetType === "releases" && <td width='23%'>{list?.customID}</td>}

                                                {(AssetType === "tracks") && <td width={AssetType === "tracks" ? '30%' : "30%"}>{list?.ISRC}</td>}
                                                {(AssetType === "tracks") && <td width={AssetType === "tracks" ? '30%' : "30%"}>{list?.trackTitle}</td>}
                                                {(AssetType === "tracks") && <td width={AssetType === "tracks" ? '30%' : "30%"}>{list?.trackArtist}</td>}


                                                {(AssetType === "songs") && <td width={AssetType === "songs" ? '30%' : "30%"}>{list?.songCode}</td>}
                                                {(AssetType === "songs") && <td width={AssetType === "songs" ? '30%' : "30%"}>{list?.songTitle}</td>}
                                                {(AssetType === "songs") && <td width={AssetType === "songs" ? '30%' : "30%"}>{list?.songWriters}</td>}
                                            </tr>
                                        </>)
                                    })}</>}

                                </tbody>
                            </table>
                        </div>}

                        {(totalRows === 0) && <div className={'ws-12 pbxl mbl'}><span className="text-center text-bold ws-12 mtl"> No Data Available. </span></div>}

                    </div>

                    {(totalRows > 0) && <div className="clearfix ws-12 pm">
                        {(() => {
                            if (totalRows > 10) {
                                return <Pagination onChange={paginationHandler} totalRows={totalRows} />
                            }
                        })()}
                    </div>}

                </div>

            </div>
        </div>
    </>)
}